var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var defaultMessages = require('../../i18n/messages/default');
var Utils = require('../../utils/Utils.js');
var UrlUtils = require('../../utils/urlUtils');
var { Button, Text } = require('@metro-ui/core');
var LoginActions = require('../../actions/LoginActions.js');
var LoginStore = require('../../stores/LoginStore.js');
var _ = require('lodash');
var AppConstants = require('../../constants/AppConstants');
var TryOtherWays = require('../LoginPreferences/TryOtherWays.js');
var UserAuthMethods = require('../LoginPreferences/UserAuthMethods.js');

class WebAuthnWidget extends React.Component {
    constructor(props) {
        super(props);
        const browserSupportWebauthn = (typeof(PublicKeyCredential) != "undefined") ? true : false;
        this.state = {
            totpValue: '',
            twoFaAuthMethod: props.twoFaAuthMethod,
            totp_view_options: AppConstants.TOTP_VIEW_OPTIONS[props.twoFaAuthMethod],
            webauthnSupported : browserSupportWebauthn
        };

        this.setAuthenticationMethodOnClick = this.setAuthenticationMethodOnClick.bind(this);
    }

    componentDidMount() {
        LoginStore.webauthnCredentialsListener(this.onWebauthnCredentials.bind(this));
        LoginStore.userCredentialsCaptureListener(this.onUserCredentialsCaptured.bind(this));
        LoginActions.get2faWebAuthnCredentialsForLogin(this.props.idToken,this.props.userId,this.props.traceId);
        this.setBackToLoginUrl();
    }

    setBackToLoginUrl() {
        let props = this.props;
        let backToLoginUrl = window.location.protocol + "//" + window.location.host + AppConstants.Links.SIGN_IN_PAGE + "?" +
            AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, props.responseType) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, props.accountId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, props.localeId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state);
            
        this.setState({ backToLoginUrl: backToLoginUrl });
    }

    onUserCredentialsCaptured() {
        let appState = LoginStore.getState();
        let startSessionIdentifier = (appState.AuthCode && appState.AuthCode.redirecturi) ? UrlUtils.getParameterByName("start_session_id", appState.AuthCode.redirecturi) : UrlUtils.getParameterByName("start_session_id", window.location.href);
        let userCredentialsCaptured =  appState.userCredentialsCaptured;
        if (startSessionIdentifier)
             LoginActions.submitAuthenticatorWithSession(userCredentialsCaptured, this.props.idToken, this.props.login, this.props.countryCode, this.props.realmId, this.props.userType, this.props.traceId, startSessionIdentifier, this.props.credentialId);
        else
            (appState.AuthCode && appState.AuthCode.redirecturi) ?
                window.location.replace(appState.AuthCode.redirecturi) :
                window.location.replace(this.props.directOtpRedirectUri);

        
    }
    onWebauthnCredentials() {
        let appState = LoginStore.getState();
        if(appState.fetchWebauthnFailure){
            this.setState({ allowedCredentials: [] });
            this.setState({ challenge: "" });
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.no_device_configured_yet']), "error", true);
        }else{
            this.setState({ allowedCredentials: appState.allowedCredentials });
            this.setState({ challenge: appState.challenge });
        }
    }
   
    onValidateUserWebauthnCredential(evt) {
        evt.preventDefault();
        let appState = LoginStore.getState();
        let startSessionIdentifier = (appState.AuthCode && appState.AuthCode.redirecturi) ? UrlUtils.getParameterByName("start_session_id", appState.AuthCode.redirecturi) : UrlUtils.getParameterByName("start_session_id", window.location.href);
        LoginActions.captureWebauthnCredentials(this.state.challenge,this.state.allowedCredentials)

    }

    onBackToLogin(evt) {        
        UrlUtils.delete_cookie(AppConstants.cookie.METRO_IDENTITY);
        window.location = this.state.backToLoginUrl;
    }

    setAuthenticationMethodOnClick(authMethodItem) {
        this.props.setAuthenticationMethodOnClick(authMethodItem);
        this.setState({totp_view_options: AppConstants.TOTP_VIEW_OPTIONS[authMethodItem.authenticationMethod]});
        const totp_view_options = AppConstants.TOTP_VIEW_OPTIONS[authMethodItem.authenticationMethod];
        
        if (authMethodItem.authenticationMethod === '2FA_WEB_AUTHN') {
            LoginActions.get2faWebAuthnCredentialsForLogin(this.props.idToken,this.props.userId,this.props.traceId);
        }
    }

    renderMFAMethods() {
        return (
            <UserAuthMethods 
            {... this.props}
                phone={this.props.phone}
                emailId={this.props.emailId}
                login={this.props.login}
                idToken={this.props.idToken}
                userId={this.props.userId}
                directOtpRedirectUri={this.props.directOtpRedirectUri}
                showMFAMethods= {this.props.showMFAMethods}
                authMethodDeviceName= {this.props.authMethodDeviceName}
                twoFaAuthMethod= {this.props.twoFaAuthMethod}
                setAuthenticationMethodOnClick= {this.setAuthenticationMethodOnClick}
                userMFAMethods= {this.props.userMFAMethods}/>
        );
    }

    renderWebAuthn() {
        const keysToReplace = {
            '<mobileNum>': this.props.phone,
            '<emailId>': this.props.emailId || ''
        };
        var totp_view_options = this.state.totp_view_options;
        var headerMessage = this.props.intl.formatMessage(defaultMessages[totp_view_options.headerMessageKey]);
       
        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0"></div>
                    <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 loginFields">
                        <form id="totpForm"
                            onSubmit={this.onValidateUserWebauthnCredential.bind(this)}>
                            <div className="totp form-group">
                                <label className="control-label form-labels paragraphHeader">
                                    <span>
                                        {
                                            Utils.replaceAllByKeys(
                                                headerMessage,
                                                keysToReplace
                                            )
                                        }
                                    </span>
                                </label>
                                <div className="clearfix">
                                    <div className="pull-left">
                                        <b>
                                            {this.props.intl.formatMessage(defaultMessages['touch_webauthn'])}
                                        </b>
                                    </div>
                                </div>
                                 <center>
                                    <img className=" img-responsive webauthnimage" id='webauthn' alt='Fingerptint Authentication' src='assets/images/fingerprint.png' />
                                </center>
                                {!this.state.webauthnSupported && <Text className= "margin-top-small" size= "small" color="warning">
                                    *{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.browswer_not_supported'])}
                                </Text>}
                                {this.state.allowedCredentials && this.state.allowedCredentials.length === 0 && <Text className= "margin-top-small" size= "small" color="warning">
                                    *{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.authenticators_not_available'])}
                                </Text>}
                                <div  className="margin-top-small">
                                    <Button 
                                        isWide
                                        id="submit" 
                                        type="submit"
                                        isFullWidth= {true}
                                        variant='primary' 
                                        size="large" 
                                        value="submit" 
                                        block
                                        isDisabled={(!this.state.webauthnSupported) || (typeof(this.state.allowedCredentials) === 'undefined' || this.state.allowedCredentials.length === 0)}
                                       
                                    >
                                        {this.props.intl.formatMessage(defaultMessages['proceed_to_authenticator'])}
                                    </Button>
                                </div>
                                
                            </div>
                            <div className="row">
                                <div className="forgotPasswordLink">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div>
                                            <a href="javascript:void(0)" onClick={this.onBackToLogin.bind(this)} className="blue-labels">
                                                {this.props.intl.formatMessage(defaultMessages['backToLogin'])}
                                            </a>
                                        </div>
                                    </div>
                                    {
                                    this.props.showTryOtherLink ? 
                                        <div className="pull-right col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <TryOtherWays showMFAMethods= {this.props.showMFAMethods}/>
                                        </div> : null
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0"></div>
                </div>
            </div>
        );
    }

    render() {
        return (
            this.props.showMFAMethodsBox? this.renderMFAMethods() : this.renderWebAuthn()

        )
    }
}


module.exports = injectIntl(WebAuthnWidget);
